module.exports = __webpack_public_path__ + "img/heading_uk.960c4cf9.svg";